export enum GameId {
  Solitaire = 'solitaire',
  Blocks = 'blocks',
  Blackjack = 'blackjack',
}

export const CurrentlySupportedGames = [GameId.Blackjack, GameId.Blocks, GameId.Solitaire];
